import { render, staticRenderFns } from "./questionType14.vue?vue&type=template&id=55d78626&scoped=true"
import script from "./questionType14.vue?vue&type=script&lang=js"
export * from "./questionType14.vue?vue&type=script&lang=js"
import style0 from "./questionType14.vue?vue&type=style&index=0&id=55d78626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d78626",
  null
  
)

export default component.exports